import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MibIconComponent, MibIconName } from '@medinbox/angular';

@Component({
  selector: 'mai-section-header',
  imports: [MibIconComponent],
  templateUrl: './section-header.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'border-mib-divider flex min-h-14 shrink-0 items-center gap-3 border-b bg-white px-4',
  },
})
export class SectionHeader {
  readonly heading = input.required<string>();
  readonly icon = input<MibIconName>();
}
